import HtmlComponent from './HtmlComponent';

export { default as HtmlComponent } from './HtmlComponent';
export { HtmlComponentContainer } from './components';

export default HtmlComponent;
